import { render, staticRenderFns } from "./ServiceSupportDetail.vue?vue&type=template&id=43ddbd42&"
import script from "./ServiceSupportDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceSupportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports